import React from "react";
import {Button, Card, Divider} from "antd";
import { useAuth } from "../../context/AuthContext";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import "./PolitiqueConfidentialitePage.css";
import { ROUTES } from "../../Routes/Routes";

const PolitiqueConfidentialitePage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="terms-page">
            <Card className="terms-card" bordered>
                <div className="terms-header">
                    <img src={logo} alt="Logo UAMA" className="terms-logo" />
                    <h1 className="terms-title">Politique de Confidentialité</h1>
                    {user && (
                        <p className="terms-greeting">
                            Bonjour <strong>{user["Nom complet"]}</strong>, voici les informations sur la confidentialité de vos données.
                        </p>
                    )}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", width: "100%", marginTop: "2vh" }}>
                        <p style={{ margin: 0 }}><strong>Date de publication : </strong>avril 2025</p>
                    </div>
                </div>

                <Divider />

                <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                    <div className="terms-section">
                        <h2>1. Nature des données collectées</h2>
                        <p>
                            L'application UAMA ne collecte aucune donnée personnelle à des fins commerciales.
                            Les seules données utilisées sont celles nécessaires au bon fonctionnement de la plateforme :
                            comptes utilisateurs, identifiants, préférences et éléments de gestion liés aux contrats.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>2. Stockage local</h2>
                        <p>
                            Des informations peuvent être stockées dans votre navigateur via le localStorage, afin d'améliorer l'expérience utilisateur (ex. : session, préférences).
                            Aucune donnée n’est transmise à des tiers.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>3. Sécurité</h2>
                        <p>
                            Les données sont stockées de manière sécurisée sur un serveur personnel. Les mots de passe sont chiffrés et l'accès est restreint.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>4. Droits des utilisateurs</h2>
                        <p>
                            Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d’un droit d’accès, de modification et de suppression de vos données personnelles.
                            <br />
                            Pour toute demande, contactez : <strong>thibaud_dufour[at]icloud.com</strong> (remplacer [at] par @).
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>5. Absence de cookies tiers</h2>
                        <p>
                            Le site n’utilise aucun cookie tiers à des fins de publicité ou de suivi. Il est exempté de bannière de consentement.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>6. Évolutions</h2>
                        <p>
                            Cette politique pourra être mise à jour en fonction de l’évolution de la plateforme. La date de dernière mise à jour sera affichée.
                        </p>
                    </div>
                </div>

                <Divider />

                <Button type="primary" block icon={<LeftOutlined/>} onClick={() => navigate(ROUTES.HOME)}>
                    Retour à l'accueil
                </Button>
            </Card>
        </div>
    );
};

export default PolitiqueConfidentialitePage;
